import { render, staticRenderFns } from "./GoogleUpdates.vue?vue&type=template&id=0445e9f8&scoped=true&"
import script from "./GoogleUpdates.vue?vue&type=script&lang=js&"
export * from "./GoogleUpdates.vue?vue&type=script&lang=js&"
import style0 from "./GoogleUpdates.vue?vue&type=style&index=0&id=0445e9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445e9f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})
